import { ApolloProvider } from '@apollo/client/react';

import { EmailPreferencesTable } from '../features/settings/email-preferences-table/EmailPreferencesTable';
import { client } from '../graphql/client';

type Props = {
  employerId: string;
};

export const EmailPreferencesTableApp: React.FC<Props> = props => (
  <ApolloProvider client={client}>
    <EmailPreferencesTable {...props} />
  </ApolloProvider>
);

EmailPreferencesTableApp.displayName = 'EmailPreferencesTableApp';
